require('./RAHireManagementPlanSuccessFooter.scss');

// @vendors
const React = require('react');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @constants
const { MYPROFILE_BROKER_ROBO_URL } = require('../../../raConstants/index');

class RAHireManagementPlanSuccessFooter extends React.Component {
    render() {
        return (
            <div className="ra-hire-management-plan-success-footer">
                <div className="grid-view__body row">
                    <div className="col-md-12">
                        <div className="ra-hire-management-plan-success-footer__container">
                            <h2 className="ra-hire-management-plan-success-footer__title">
                                <FormattedText value="raHireManagementPlanSuccess-footerTitle" />
                            </h2>
                            <div className="row">
                                <div className="ra-hire-management-plan-success-footer__info-container col-md-4">
                                    <i className="ra-hire-management-plan-success-footer__icon icon icon-incremento-moderado" />
                                    <h3>
                                        <FormattedText
                                            value="raHireManagementPlanSuccess-raHireManagementPlanSuccessFooter_firstInfoTitle"
                                            className="ra-hire-management-plan-success-footer__sub-title"
                                        />
                                    </h3>
                                    <FormattedText
                                        value="raDotsLineIcons-firstItem"
                                        className="ra-hire-management-plan-success-footer__info"
                                    />
                                </div>
                                <div className="ra-hire-management-plan-success-footer__info-container col-md-4">
                                    <i className="ra-hire-management-plan-success-footer__icon icon icon-analisis-tecnico" />
                                    <h3>
                                        <FormattedText
                                            value="raHireManagementPlanSuccess-raHireManagementPlanSuccessFooter_secondInfoTitle"
                                            className="ra-hire-management-plan-success-footer__sub-title"
                                        />
                                    </h3>
                                    <FormattedText
                                        value="raDotsLineIcons-middleItem"
                                        className="ra-hire-management-plan-success-footer__info"
                                    />
                                </div>
                                <div className="ra-hire-management-plan-success-footer__info-container col-md-4">
                                    <i className="ra-hire-management-plan-success-footer__icon icon icon-rentabilidad" />
                                    <h3>
                                        <FormattedText
                                            value="raHireManagementPlanSuccess-raHireManagementPlanSuccessFooter_thirdInfoTitle"
                                            className="ra-hire-management-plan-success-footer__sub-title"
                                        />
                                    </h3>
                                    <FormattedText
                                        value="raDotsLineIcons-lastItem"
                                        className="ra-hire-management-plan-success-footer__info"
                                    />
                                </div>
                            </div>
                            <div className="ra-hire-management-plan-success-footer__footer-bottom">
                                <OKButton
                                    inverse={true}
                                    modifier="ghost"
                                    to={MYPROFILE_BROKER_ROBO_URL}
                                >
                                    <FormattedText value="raHireManagementPlanSuccess-raHireManagementPlanSuccess_ctaButton" />
                                </OKButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = RAHireManagementPlanSuccessFooter;
